/* React */
import React from "react";

/* Components */
import FilterLabel from "src/components/shared/labels/filter-label/FilterLabel";
import BooleanSelect from "src/components/insights/custom-cohorts/cohort-builder/value-selector/boolean-select/BooleanSelect";
import NumericSelect from "src/components/insights/custom-cohorts/cohort-builder/value-selector/numeric-select/NumericSelect";
import ConceptSelect from "src/components/insights/custom-cohorts/cohort-builder/value-selector/concept-select/ConceptSelect";

/* Stylesheet */
import styles from "./ValueSelector.module.scss";

/* Interfaces */
import {
  BasicProps,
  EntityType,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

import { getFilterLabel } from "src/components/insights/custom-cohorts/cohort-builder/value-selector/value-selector";

interface ValueSelectorProps {
  segment: BasicProps;
  disabled: boolean;
  handleUpdate: <K extends keyof BasicProps>(
    key: K,
    data?: {
      value?: BasicProps[K];
      values?: BasicProps[K];
      boundaries?: BasicProps[K];
    }
  ) => void;
}

const ValueSelector: React.FC<ValueSelectorProps> = ({
  segment,
  disabled,
  handleUpdate,
}) => {
  const componentMapper = () => {
    if (!segment || !segment.entity) return null;

    const { entity, value, values, boundaries } = segment;
    const { range } = entity;

    switch (entity.type) {
      case EntityType.BOOLEAN:
        return (
          <BooleanSelect
            options={entity.options as boolean[]}
            value={value ?? false}
            disabled={disabled}
            handleUpdate={handleUpdate}
          />
        );
      case EntityType.NUMERIC:
        return (
          <NumericSelect
            range={range!}
            boundaries={
              boundaries ?? {
                lowerBound: range!.min,
                upperBound: range!.max,
              }
            }
            handleUpdate={handleUpdate}
            disabled={disabled}
          />
        );
      case EntityType.CONCEPT:
        return (
          <ConceptSelect
            options={entity.options as string[]}
            values={values ?? []}
            disabled={disabled}
            handleUpdate={handleUpdate}
          />
        );
      case EntityType.UNSUPPORTED:
        return <div>Not supported</div>;
      default:
        return null;
    }
  };

  return (
    <div className={styles.value_selector}>
      <FilterLabel
        scssProps={{
          margin: "42px 0px 12px 16px",
          color: disabled
            ? "var(--ion-color-text-disabled)"
            : "var(--ion-color-text-primary)",
        }}
        label={getFilterLabel(segment)}
      />
      {componentMapper()}
    </div>
  );
};

export default ValueSelector;
